import { useCallback, useEffect, useState } from "react";
import { academyRequest } from "./academyApi";

export type InstructorAttendanceAnalytics = {
  metricKey: "learning.attendance_status_count";
  definitionVersion: number;
  sourceDomain: "D10";
  availability: "available" | "stale" | "not_projected";
  values: Partial<Record<"PRESENT" | "LATE" | "ABSENT" | "EXCUSED" | "UNKNOWN", number>>;
  suppressedCells: number;
  minimumCellCount: number;
  freshnessSeconds: number;
  calculatedAt: string | null;
  expiresAt: string | null;
  instructorUserId: string;
  individualAnalysisAvailable: false;
  outcomesAvailable: false;
  transactionalAuthority: false;
  exportAvailable: false;
};

export function useInstructorAttendanceAnalytics(enabled: boolean) {
  const [data, setData] = useState<InstructorAttendanceAnalytics>();
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError("");
    try {
      setData(
        await academyRequest<InstructorAttendanceAnalytics>("instructor/dashboard/analytics/attendance"),
      );
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Instructor attendance analytics are unavailable.");
    } finally {
      setLoading(false);
    }
  }, [enabled]);
  useEffect(() => {
    if (enabled) void refresh();
    else {
      setData(undefined);
      setError("");
      setLoading(false);
    }
  }, [enabled, refresh]);
  return { data, loading, error, refresh };
}
